import { IMaintenanceResponse } from "@/store/apis/maintenanceAPI"
import { STORE_CURRENCY } from "@/store/apis/storePaymentsAPI"

interface IAppSliceStateError {
  message: string
  serverMessage: string
  status: number
  code: number
  data: any
  url: string
}

export interface IAppSliceState {
  errorObject: IAppSliceStateError
  language: string
  isLoaded: boolean
  isLabrUser: boolean
  pageStyle: IPageStyle
  isDevMode: boolean
  isDesktop: boolean
  isPhoneDevice: boolean
  maintenance: IMaintenanceResponse
  volume: number
  isTMA: boolean
  reAuthState: "idle" | "loading" | "error"
  screen: {
    width: number
    height: number
  }
  storeCurrency: STORE_CURRENCY
  isDev: boolean
}

export const PAGE_STYLE = {
  GREEN: "green",
  BROWN: "brown",
  PURPLE: "purple",
  BROWN_LIGHT: "brown-light",
  BURGUNDY: "burgundy",
  TON: "ton"
} as const

export type IPageStyle = (typeof PAGE_STYLE)[keyof typeof PAGE_STYLE]
